import { Box, Grid, List, ListItem, ListItemIcon, ListItemText, Typography, useMediaQuery } from "@mui/material";
import { default as fintech } from "../../assets/development.png"
import { theme } from "../../common/style/Theme";
import { Bolt, Campaign, DirectionsRun, DoubleArrow, Groups, Handshake, Psychology, Work } from "@mui/icons-material";
import { default as education } from "../../assets/agri.jpg";

const About = () => {
    // Media queries for responsive design
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'lg'));
    
    const coreValues = [
        {
            icon: <Psychology style={{
                color: theme.palette.secondary.main,
                fontSize: "2rem",
            }}/>,
            title: "Innovation with Purpose",
            description: "We build not just for technology’s sake, but to solve real-world challenges that matter.",
        },
        {
            icon: <Handshake style={{
                color: theme.palette.secondary.main,
                fontSize: "2rem",
            }}/>,
            title: "Integrity & Trust",
            description: "We believe long-term relationships — with clients, communities, and partners — are built on transparency and accountability.",
        },
        {
            icon: <Bolt style={{
                color: theme.palette.secondary.main,
                fontSize: "2rem",
            }}/>,
            title: "Empowerment",
            description: "Whether it’s a farmer, a rural entrepreneur, or a young developer — we exist to enable growth through the right tools and knowledge.",
        },
        {
            icon: <Groups style={{
                color: theme.palette.secondary.main,
                fontSize: "2rem",
            }}/>,
            title: "Collaboration Over Competition",
            description: "We co-create with stakeholders and industry partners to ensure mutual success and sustainable impact",
        },
        {
            icon: <DirectionsRun style={{
                color: theme.palette.secondary.main,
                fontSize: "2rem",
            }}/>,
            title: "Agility & Excellence",
            description: "We adapt quickly and execute with discipline — whether we’re launching a pilot or scaling nationwide.",
        }
    ]
    const culture = [
        {
            icon: <Campaign style={{
                fontSize: "1.5rem",
                color: theme.palette.warning.main,
            }}/>,
            title: "⁠Every voice matters",
            description: "We listen, learn, and grow together"
        },
        {
            icon: <Psychology style={{
                fontSize: "1.5rem",
                color: theme.palette.warning.main,
            }}/>,
            title: "Ideas turn into impact",
            description: "From incubation to implementation, we support innovation at every level."
        },
        {
            icon: <Groups style={{
                fontSize: "1.5rem",
                color: theme.palette.warning.main,
            }}/>,
            title: "Teams feel ownership",
            description: "You don’t just work in the company; you help shape it."
        },
        {
            icon: <Work style={{
                fontSize: "1.5rem",
                color: theme.palette.warning.main,
            }}/>,
            title: "⁠Work meets purpose",
            description: "What we build helps real people solve real challenges every day."
        }
    ]
    const process = [
        {
            title: "Understand the Problem",
            description: "We start with ground-level research and real stakeholder engagement to define the challenge."
        },
        {
            title: "Design for Users",
            description: "Our solutions are built around user needs — be it a farmer, processor, field executive, or business owner."
        },
        {
            title: "Develop Rapid Prototypes",
            description: "We move quickly to create MVPs that are tested in the field and refined in real-time."
        },
        {
            title: "Build Scalable Solutions",
            description: "Using robust tech stacks, multilingual interfaces, and mobile-first design, we ensure the platform is ready to grow."
        },
        {
            title: "Enable Adoption",
            description: "Training, digital campaigns, and partner onboarding are built into every rollout strategy."
        },
        {
            title: "⁠Measure & Improve",
            description: "We track usage, feedback, and outcomes to continuously enhance platform performance and impact."
        }
    ]
    const m5Choice = [
        {
            title: "⁠Domain Depth",
            description: "Over a decade of experience in building custom platforms for niche sectors, especially agriculture, manufacturing, distribution & supply chain, Retail and Ecommerce, Service Industry, Rural and social enterprises.",
        },
        {
            title: "⁠Product Innovation",
            description: "Creators of the Millman ERP and the robust Bhoomee Digital Agri Platform.",
        },
        {
            title: "Platform Thinkers",
            description: "Not just software builders — we create ecosystems.",
        },
        {
            title: "Agility & Collaboration",
            description: "Whether it’s end-to-end development or co-creating with your in-house teams, we bring flexibility and focus.",
        },
        {
            title: "Purpose-Driven",
            description: "Every solution we build solves real-world problems and aims for impact at scale."
        }
    ]

    return (
        <Box>
            <Box style={{
                width: "100vw",
                height: isMobile ? "90vh" : "calc(1rem * 25 + 2.1rem * 5 + 100px)",
                position: "relative",
            }}>
                <img src={fintech} style={{
                    width: "100%",
                    height: "100%",
                    objectPosition: "left",
                    objectFit: "cover"
                }} alt="about-bg"/>
                <Box style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: isMobile ? "90vh" : "calc(1rem * 25 + 2.1rem * 5 + 100px)",
                    opacity: 0.84,
                    background: theme.palette.common.black
                }} />
                <Grid container style={{
                    position: "absolute",
                    width: "100vw",
                    height: isMobile ? "90vh" : "calc(1rem * 25 + 2.1rem * 5 + 100px)",
                    top: 0,
                    left: 0,
                    padding: isMobile ? "10vh 5vw" : isTablet ? "12vh 8vw" : "15vw"
                }}>   
                    <Grid size={{xs:12, sm:12, md:12, lg:12}}>
                        <Box style={{
                            color: theme.palette.common.white,
                            display: "flex",
                            flexDirection: isMobile ? "column" : "row",
                        }}>
                            {!isMobile && !isTablet && <Typography variant="h2" style={{
                                fontFamily: "cursive",
                                fontSize: "170px",
                                fontWeight: 600,
                                marginTop: isMobile ? "0" : isTablet ? "-50px" : "-100px",
                                alignSelf: isMobile ? "flex-start" : "flex-start",
                            }}>
                                "
                            </Typography>}
                            <Typography variant="body1" style={{
                                marginTop: isMobile ? "10px" : "20px",
                                marginLeft: isMobile ? "0" : "20px",
                                textAlign: "justify",
                                lineHeight: isMobile ? "1.5" : "1.5",
                            }}>
                                M5 Info Solutions, established in 2011, is a technology company with deep expertise in building customized software solutions across diverse industries. From developing ERP systems for incense manufacturers with operations in India and Africa, to creating workflow automation for pan-India pharma distributors and effluent treatment plants, 
                                M5 has consistently delivered robust, scalable solutions. Our flagship ERP product, Millman, transformed operations for rice mills across Karnataka, earning us a reputation for domain-led innovation.  A simple integration request from a rice mill led to the creation of Bhoomee, now a mission-driven digital agri platform connecting farmers and agri-stakeholders nationwide. 
                                With a strong foundation in software development, project execution, and process consulting, M5 continues to serve businesses seeking reliable technology partners for enterprise applications, process automation, and digital transformation.
                            </Typography>
                        </Box>
                        <Box style={{
                            color: theme.palette.common.white,
                            display: "flex",
                            justifyContent: isMobile ? "center" : "flex-end",
                            marginTop: isMobile ? "30px" : "20px"
                        }}>
                            <Typography variant="h3" style={{
                                fontWeight: 800,
                                textAlign: isMobile ? "center" : "right",
                                color: theme.palette.common.white,
                                letterSpacing: isMobile ? "2px" : "3px",
                                WebkitTextStroke: `1.5px ${theme.palette.common.white}`,
                                textShadow: `1px 0px 1px ${theme.palette.background.default}`,
                            }}>
                                About M5
                            </Typography>  
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            <Grid container style={{
                padding: isMobile ? "0 4vw" : isTablet ? "0 6vw" : "0 8vw",
                backgroundColor: theme.palette.background.paper,
                flexDirection: isMobile ? "column" : "row",
            }}>
                <Grid size={{xs:12, sm:12, md:6, lg:6}} style={{
                    padding: isMobile ? "6vw 3vw" : isTablet ? "4vw 4vw" : "3vw 5vw",
                    borderRight: isMobile ? "none" : "2px solid",
                    borderBottom: isMobile ? "2px solid" : "none",
                    borderImage: isMobile ? 
                        `linear-gradient(to right, ${theme.palette.background.paper}, ${theme.palette.background.default}, ${theme.palette.background.paper}) 1` :
                        `linear-gradient(to bottom, ${theme.palette.background.paper}, ${theme.palette.background.default}, ${theme.palette.background.paper}) 1`,
                    boxSizing: "border-box",
                }}>
                    <Typography variant="h3" style={{
                        fontWeight: 800,
                        color: theme.palette.secondary.main,
                        letterSpacing: isMobile ? "2px" : "3px",
                        fontSize: isMobile ? "2rem" : isTablet ? "2.5rem" : "3rem",
                        WebkitTextStroke: `1.5px ${theme.palette.secondary.main}`,
                        textShadow: `1px 0px 1px ${theme.palette.background.default}`,
                        paddingBottom: "20px",
                        textAlign: isMobile ? "center" : "left",
                    }}>
                        Vision
                    </Typography>
                    <Typography variant="body1" style={{
                        textAlign: "justify",
                        lineHeight: isMobile ? "1.6" : "1.5",
                    }}>
                        To build purpose-driven digital platforms that solve real problems, empower communities, and transform traditional industries — expanding into every sector where technology can be a force for good.
                    </Typography>
                </Grid>
                <Grid size={{xs:12, sm:12, md:6, lg:6}} style={{
                    padding: isMobile ? "6vw 3vw" : isTablet ? "4vw 4vw" : "3vw 5vw",
                }}>
                    <Typography variant="h3" style={{
                        fontWeight: 800,
                        color: theme.palette.secondary.main,
                        letterSpacing: isMobile ? "2px" : "3px",
                        fontSize: isMobile ? "2rem" : isTablet ? "2.5rem" : "3rem",
                        paddingBottom: "20px",
                        WebkitTextStroke: `1.5px ${theme.palette.secondary.main}`,
                        textShadow: `1px 0px 1px ${theme.palette.background.default}`,
                        textAlign: isMobile ? "center" : "left",
                    }}>
                            Mission
                    </Typography>
                    <Typography variant="body1" style={{
                        textAlign: "justify",
                        lineHeight: isMobile ? "1.6" : "1.5",
                    }}>
                        To design and deliver intelligent, scalable, and inclusive software solutions that:
                    </Typography>
                    <List style={{padding: 0}}>
                        <ListItem style={{padding: 0}}>
                            <ListItemIcon style={{minWidth: "35px"}}>
                                <DoubleArrow style={{color: theme.palette.secondary.main}} />    
                            </ListItemIcon>
                            <ListItemText primary="⁠Empower small and medium businesses"/>
                        </ListItem>
                        <ListItem style={{padding: 0}}>
                            <ListItemIcon style={{minWidth: "35px"}}>
                                <DoubleArrow style={{color: theme.palette.secondary.main}} />    
                            </ListItemIcon>
                            <ListItemText primary="⁠Bridge rural and urban ecosystems"/>
                        </ListItem>
                        <ListItem style={{padding: 0}}>
                            <ListItemIcon style={{minWidth: "35px"}}>
                                <DoubleArrow style={{color: theme.palette.secondary.main}} />    
                            </ListItemIcon>
                            <ListItemText primary="⁠Enable data-driven decision-making"/>
                        </ListItem>
                        <ListItem style={{padding: 0}}>
                            <ListItemIcon style={{minWidth: "35px"}}>
                                <DoubleArrow style={{color: theme.palette.secondary.main}} />    
                            </ListItemIcon>
                            <ListItemText primary="⁠Create impact at scale through technology"/>
                        </ListItem>
                    </List>
                </Grid>   
            </Grid>
            <Grid container style={{
                padding: isMobile ? "8vw 5vw" : isTablet ? "6vw 8vw" : "5vw 10vw",
                background: `linear-gradient(50deg, ${theme.palette.primary.main}, ${theme.palette.common.black})`,
                color: theme.palette.common.white,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }} spacing={isMobile ? 4 : isTablet ? 6 : 10}>
                <Grid size={{xs:12, sm:12, md:12, lg:12}} style={{
                    textAlign: "center",
                    marginBottom: isMobile ? "20px" : "0",
                }}>
                    <Typography variant="h2" style={{
                        marginBottom: isMobile ? "20px" : "40px",
                        color: theme.palette.common.white
                    }}>
                        Our Core Values
                    </Typography>
                </Grid>
                {coreValues.map((value, index) => (
                    <Grid size={{xs:12, sm:6, md:4, lg:4}} key={index} style={{
                        marginBottom: isMobile ? "30px" : "0",
                    }}>
                        <Box style={{
                            width: "1rem",
                            height: "1rem",
                            padding: "20px",
                            borderRadius: "50%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            borderBottom: `1px solid ${theme.palette.secondary.main}`,
                            borderRight: `1px solid ${theme.palette.secondary.main}`,
                            marginBottom: "10px",
                            margin: isMobile ? "0 auto 15px auto" : "0 0 10px 0",
                        }}>
                            {value.icon}
                        </Box>
                        <Typography variant="h5" style={{
                            fontWeight: 600,
                            marginBottom: "20px",
                            color: theme.palette.background.paper,
                            textAlign: isMobile ? "center" : "left",
                        }}>
                            {value.title}
                        </Typography>
                        <Typography variant="body1" style={{
                            lineHeight: isMobile ? "1.6" : "1.5",
                            textAlign: isMobile ? "center" : "left",
                        }}>
                            {value.description}
                        </Typography>
                    </Grid>
                ))}
            </Grid>
            <Grid container style={{
                padding: isMobile ? "8vw 5vw" : isTablet ? "6vw 8vw" : "5vw 10vw",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }} spacing={isMobile ? 4 : isTablet ? 6 : 10}>
                <Grid size={{xs:12, sm:12, md:12, lg:12}} style={{
                    textAlign: "center",
                    marginBottom: isMobile ? "20px" : "0",
                }}>
                    <Typography variant="h2">
                        Our Culture
                    </Typography>
                </Grid>
                <Grid size={{xs:12, sm:12, md:4, lg:4}} style={{
                    order: isMobile ? 2 : 1,
                    marginTop: isMobile ? "30px" : "0",
                }}>
                    <Box style={{
                        position: "relative",
                        width: "100%",
                        height: isMobile ? "300px" : isTablet ? "350px" : "400px",
                        background: `linear-gradient(50deg, ${theme.palette.warning.main}, ${theme.palette.secondary.main})`,
                        borderRadius: "10px",
                    }}>
                        <Box style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: isMobile ? "300px" : isTablet ? "350px" : "400px",
                            borderRadius: "10px",
                            marginTop: "20px",
                            marginLeft: "20px",
                        }}>
                            <img src={education} style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                borderRadius: "10px",
                            }} alt="education"/>
                        </Box>
                    </Box>
                </Grid>
                <Grid size={{xs:12, sm:12, md:8, lg:8}} style={{
                    paddingLeft: isMobile ? "0" : isTablet ? "3vw" : "5vw",
                    order: isMobile ? 1 : 2,
                }}>
                    <Typography variant="h4" style={{
                        fontWeight: 600,
                        marginBottom: "20px",
                        textAlign: isMobile ? "center" : "left",
                    }}>
                        M5 Fosters a culture where,
                    </Typography>
                    {culture.map((item, index) => (
                        <Box key={index} style={{
                            textAlign: isMobile ? "center" : "left",
                        }}>
                            <Box style={{
                                display: "flex",
                                alignItems: "center",
                                marginBottom: "10px",
                                justifyContent: isMobile ? "center" : "flex-start",
                                flexDirection: isMobile ? "column" : "row",
                            }}>
                                {item.icon}
                                <Typography variant="h5" style={{
                                    fontWeight: 600,
                                    marginLeft: isMobile ? "0" : "20px",
                                    marginTop: isMobile ? "10px" : "0",
                                }}>
                                    {item.title}
                                </Typography>
                            </Box>
                            <Typography variant="body1" style={{
                                marginBottom: "30px",
                                lineHeight: isMobile ? "1.6" : "1.5",
                            }}>
                                {item.description}
                            </Typography>
                        </Box>
                    ))}
                    <Typography variant="h6" style={{
                        textAlign: isMobile ? "center" : "left",
                    }}>
                        We value initiative, curiosity, and a sense of responsibility in all our team members.
                    </Typography>
                </Grid>
            </Grid>
            <Grid container style={{
                padding: isMobile ? "8vw 5vw" : isTablet ? "6vw 8vw" : "5vw 10vw",
                display: "flex",
                justifyContent: "center",
                alignItems: "stretch",
                background: theme.palette.background.paper,
            }} spacing={isMobile ? 3 : 5}>
                <Grid size={{xs:12, sm:12, md:12, lg:12}} style={{
                    textAlign: "center",
                    marginBottom: isMobile ? "20px" : "0",
                }}>
                    <Typography variant="h2">
                        Our Process
                    </Typography>
                    <Typography variant="body1" style={{
                        lineHeight: isMobile ? "1.6" : "1.5",
                        padding: isMobile ? "0 2vw" : "0",
                        marginBottom: isMobile ? "10px" : "20px",
                    }}>
                        Our end-to-end platform development and consulting process is designed to be collaborative, iterative, and impact-focused
                    </Typography>
                </Grid>
                {process.map((step, index) => (
                    <Grid size={{xs:12, sm:6, md:4, lg:4}} key={index} style={{
                        borderTopLeftRadius: "10px",
                        borderTopRightRadius: "5px",
                        borderBottomLeftRadius: "5px",
                        borderBottomRightRadius: "10px",
                        borderLeft: `20px solid ${theme.palette.primary.main}`,
                        borderTop: `20px solid ${theme.palette.warning.main}`,
                        padding: isMobile ? "20px" : isTablet ? "25px" : "30px",
                        boxShadow: "rgba(17, 12, 46, 0.15) 0px 48px 100px 0px",
                        marginBottom: isMobile ? "20px" : "0",
                    }}>

                        <Typography variant="h5" style={{
                            fontWeight: 600,
                            marginBottom: "10px",
                        }}>
                            {step.title}
                        </Typography>
                        <Typography variant="body1" style={{
                            lineHeight: isMobile ? "1.6" : "1.5",
                        }}>
                            {step.description}
                        </Typography>
                    </Grid>
                ))}
            </Grid>
            <Grid container style={{
                padding: isMobile ? "8vw 5vw" : isTablet ? "6vw 8vw" : "5vw 10vw",
                flexDirection: isMobile ? "column" : "row",
            }} id="why-m5">
                <Grid size={{xs:12, sm:12, md:12, lg:12}} style={{
                    textAlign: "center",
                    paddingBottom: isMobile ? "6vw" : "3vw",
                }}>
                    <Typography variant="h2">
                        Why Choose M5?
                    </Typography>
                </Grid>
                <Grid size={{xs:12, sm:12, md:8, lg:8}} style={{
                    order: isMobile ? 2 : 1,
                    marginTop: isMobile ? "30px" : "0",
                }}>
                    {m5Choice.map((choice, index) => (
                        <Box key={index} style={{
                            marginBottom: "10px",
                            padding: isMobile ? "15px" : "20px",
                            borderTopLeftRadius: "10px",
                            borderBottomLeftRadius: "10px",
                            backgroundColor: theme.palette.background.paper,
                            border: `1px solid ${theme.palette.background.default}`
                        }}>
                            <Typography variant="h6" style={{
                                fontWeight: 600,
                                marginBottom: "10px",
                            }}>
                                {choice.title}
                            </Typography>
                            <Typography variant="body2" style={{
                                marginTop: "-8px",
                                lineHeight: isMobile ? "1.6" : "1.43",
                            }}>
                                {choice.description}
                            </Typography>
                        </Box>
                    ))}
                </Grid>
                <Grid size={{xs:12, sm:12, md:4, lg:4}} style={{
                    order: isMobile ? 1 : 2,
                }}>
                    <Box style={{
                        borderTopRightRadius: isMobile ? "10px" : "50px",
                        borderBottomRightRadius: isMobile ? "10px" : "50px",
                        borderTopLeftRadius: isMobile ? "10px" : "0",
                        borderBottomLeftRadius: isMobile ? "10px" : "0",
                        width: "100%",
                        height: isMobile ? "250px" : "98%"
                    }}>
                        <img src={fintech} style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderTopRightRadius: isMobile ? "10px" : "50px",
                            borderBottomRightRadius: isMobile ? "10px" : "50px",
                            borderTopLeftRadius: isMobile ? "10px" : "0",
                            borderBottomLeftRadius: isMobile ? "10px" : "0",
                        }} alt="fintech"/>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    )
}

export default About;